"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DeleteBucketLifecycleInput_1 = require("./DeleteBucketLifecycleInput");
var DeleteBucketLifecycleOutput_1 = require("./DeleteBucketLifecycleOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.DeleteBucketLifecycle = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "DeleteBucketLifecycle",
    http: {
        method: "DELETE",
        requestUri: "/{Bucket}?lifecycle"
    },
    input: {
        shape: DeleteBucketLifecycleInput_1.DeleteBucketLifecycleInput
    },
    output: {
        shape: DeleteBucketLifecycleOutput_1.DeleteBucketLifecycleOutput
    },
    errors: []
};
//# sourceMappingURL=DeleteBucketLifecycle.js.map